module.exports = __webpack_public_path__ + "img/icon-hamburger-menu.db5d7e83.svg";